import config from '../../config/generated.json'

export default function isFooterBrandLogoShown(): boolean {
  return config.ui.showFooterBrandLogo
}
